<template>
<b-container>
    <h1>{{ $t("tracking.occurrenceType.create") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" /> 
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    
    <b-form @submit.prevent="save">
      <b-row class="mb-3 ml-0">
          <router-link :to="getUrlBackToList">
            <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
          </router-link>
        </b-row>
      <b-row>
        <b-col sm="12" md="6" lg="6">
          <occurrence-type-crud-data
            :model="model"
            :modelstate="modelstate"
            :readonly="false"
            class="mb-4"
          >
          </occurrence-type-crud-data>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col>
          <b-button type="submit" :disabled="submitted">
            {{ $t("geral.save") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <div>
      <!-- {{model}} -->
    </div>
   
</b-container>

</template>

<script>

export default {
  name: "OccurrenceTypeCreate",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    OccurrenceTypeCrudData: () =>
      import(
        "@/components_rms/trackingShippingCompany/occurrenceType/occurrenceTypeCrudData.vue"
      ),
    
  },

  data() {
    return {
      alert: {
        error: "",
        success: "Ocorrência criada com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        sequenceNumber: "",
        description : "",
        profiles: [],
        occurrenceTypeNext: [],   
        customFields: [],
      },
    };
  },
  created() {    
    this.loadavailableProfiles();
    this.newModel();
    this.loadOccurrenceTypeNext();
  },
  computed: {
    getUrlBackToList() {
      return `/trackingShippingCompany/occurrenceType/list`;
    },
    getUrlavailableProfiles() {    
        return `/v1/occurrenceType/availableProfiles/`;              
    },
    getNewModel() {
      return `/v1/occurrenceType/newModel`
    },
    getAllById(){
      return `/v1/occurrenceType/getAll`
    }
  },
  methods: {    
    async newModel()
    {
      console.log(this.getNewModel)
      this.$api
      .get(this.getNewModel)
      .then((response) => {
        // console.log("entrou")
        // console.log(response.data);
        let model = response.data;
        this.model.sequenceNumber = model;
        this.model.description = " ";
        console.log(model.sequenceNumber)
      })
    },
    async loadOccurrenceTypeNext()
    {
      console.log(this.getAllById)
      this.$api
      .get(this.getAllById)
      .then((response) => {
        // console.log("entrou")
        // console.log(response.data);
        let model = response.data;
        this.model.occurrenceTypeNext = model;
        console.log(model.occurrenceTypeNext)
      })
      .catch((error) => {
          if (error.response.status == 401) {
            console.log(response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log(response.data);
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    async loadavailableProfiles()
    {
      console.log(this.getUrlavailableProfiles)
      this.$api
      .get(this.getUrlavailableProfiles)
      .then((response) => {
        // console.log("entrou")
        // console.log(response.data);
        let model = response.data;
        this.model.profiles = model;
        console.log(model.profiles)
      })
      .catch((error) => {
          if (error.response.status == 401) {
            console.log(response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log(response.data);
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  save() {
    this.submitted = true;
    
    this.$api
      .post("/v1/occurrenceType/create", this.model)
      .then((response) => {
        this.newModel();
        this.loadavailableProfiles();
        this.newModel();
        this.$refs.alert.show();
        this.modelstate = {};
        this.submitted = false;
      })
      .catch((error) => {
        this.submitted = false;
        this.modelstate = {};
        if (error.response) {
          console.log(error.response);
          if (error.response.status == 400) {
            console.log(error.response);
            console.log(error.response.data);
            console.log(error.response.data.errors);
            this.modelstate = error.response.data.errors;
            this.alert.error = "Verifique os dados informados";
          } else {
            if (error.response.data) {
              console.log(error.response.data);
              this.alert.error = `${error.response.status} - ${error.response.statusText} `;
            } else {
              this.alert.error = `${error.response.status} - ${error.response.statusText} `;
            }
          }
        } else {
          this.alert.error = error.message;
        }
        this.$refs.fadeAlertDanger.show();
      });
  },
  }
};
</script>
